import React, {Component} from 'react';
import Title from '../../SubscriptionsInfo/Title/Title';
import DateSelection from '../DateSelection/Date';
import SearchBar from '../../SubscriptionsInfo/SearchBar/SearchBar'
import InsightsTable from './insightsTable';
import moment from 'moment';
import Page from '../../framework/Page/Page';
import {
  downLoadCSVFunc
} from "../../../utils/utility";
// css
import './insights-info-s.css'
class Insights extends Component {
  constructor(props) {
    super(props)
    this.throttle = true;
    this.state = {
      requestParams: {
        clientId: '',
        pageNumber: 1,
        pageSize: 15,
        sortColumn: 'clientName',
        order: 'asc',
        dateFrom: moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: moment().format('YYYY-MM-DD')
      }
    }
  }
  componentDidMount () {
    this.props.getSearch(this.state.requestParams)
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.search_results.insightTags &&
      this.props.search_results !== nextProps.search_results
    ) {
      this.setState({
        requestParams: {
          ...this.state.requestParams,
          pageSize: nextProps.search_results.insightTags.total
        }
      }, () => {
        this.props.getAllSearch(this.state.requestParams)
      })
    }
  }
  handleSearch (selectedItem) {
    this.props.resetData()
    let obj = {}
    if (selectedItem === '') {
      obj = {
        requestParams: {
          ...this.state.requestParams,
          clientId: '',
          pageNumber: 1,
          pageSize: 15
        }
      }
      this.goToPage(1)
    } else {
      obj = {
        requestParams: {
          ...this.state.requestParams,
          clientId: selectedItem,
          pageNumber: 1,
          pageSize: 15
        }
      }
    }
    this.setState(obj, () => {
      this.props.getSearch(this.state.requestParams);
    })
  }
  handleStartDateChange(date) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        dateFrom: date
      }
    })
  }
  handleEndDateChange(date) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        dateTo: date
      }
    })
  }
  nextBeClick (page) {
    this.pageAbleFunc(page)
  }
  previousBeClick (page) {
    this.pageAbleFunc(page)
  }
  goToPage (page) {
    this.pageAbleFunc(page)
  }
  pageAbleFunc (val) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        pageNumber: val,
        pageSize: 15
      }
    }, () => {
      this.props.getSearch(this.state.requestParams);
    })
  }
  handleSortByClientName () {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        pageSize: 15,
        order: this.state.requestParams.order === 'desc' ? 'asc' : 'desc'
      }
    }, () => {
      this.pros.getSearch(this.state.requestParams)
    })
  }
  handleApplyBeClick() {
    let obj = {
      requestParams: {
        ...this.state.requestParams,
        clientId: '',
        pageNumber: 1,
        pageSize: 15
      }
    }
    this.setState(obj, () => {
      this.props.getSearch(this.state.requestParams);
    })
  }
  handleDownload () {
    let title = 'AudienceAnywhere insights Records Delivered,,,,,\r\n'
    let _subTitle = `Tine Period,,,,,\r\n`;
    let from = `From,${moment(this.state.requestParams.dateFrom).format('M/D/YY')},,,,\r\n`;
    let to = `To,${moment(this.state.requestParams.dateTo).format('M/D/YY')},,,,\r\n`;
    let data = '';
    let fn = (item) => {
      data += `"${item.clientName}",${item.bizUnitName||''},${item.domain||''},${item.consumerRecords},${item.businessRecords}\r\n`;
    }
    for (const v of this.props.all_search_results.insightTags.data) {
      if (v.children) {
        data += `"${v.clientName}",,,,,\r\n`;
        v.children.forEach(fn)
      } else {
        data += `"${v.clientName}",${v.bizUnitName||''},${v.domain||''},${v.consumerRecords},${v.businessRecords}\r\n`;
      }
    }
    let csv_string =
      title +
      _subTitle +
      from +
      to +
      ',,,,,\r\n' +
      ',,,,,\r\n' +
      'Client Name,Business Unit Name,Web Property,Consumer Records Delivered,Business Records Delivered,\r\n' +
      data
    downLoadCSVFunc(csv_string.trim(), 'AA_Insights_Records_Delivered_' + moment().format("YYYYMMDD") );
  }
  render () {
    return (
      <div className="insights-info-s subscription-info">
        <div className="title-wrapper">
          <Title
            crumb="Data - Insights"
            handleDownload={() => this.handleDownload()}
          />
        </div>
        <div className="date-picker">
          <DateSelection
            startDateChange={(date) => this.handleStartDateChange(date)}
            endDateChange={(date) => this.handleEndDateChange(date)}
            handleApplyBeClick={() => this.handleApplyBeClick()}
          />
        </div>
        <div className="common-wrapper mt-20">
          <h2 className="border-title">
            INSIGHTS RECORDS DELIVERED BY CLIENT/BUSINESS UNIT
          </h2>
          <div className="search-bar">
            <SearchBar
              clients={this.props.clients}
              handleSearch={(selectedItem) => this.handleSearch(selectedItem)}
            />
            <div className="tag-info-table-wrapper">
              <InsightsTable
                handleSortByClientName={() => this.handleSortByClientName()}
                tableHeaderArr={
                  [
                    {label: 'Client Name', value: 0},
                    {label: 'Business Unit Name', value: 1},
                    {label: 'Web Property', value: 2},
                    {label: 'Consumer Records Delivered', value: 3},
                    {label: 'Business Records Delivered', value: 4}
                  ]
                }
                bodyDataArr={
                  this.props.search_results.insightTags ? this.props.search_results.insightTags.data : []
                }
                tableHeaderWidthStyle={
                  ['22%', '20%', '14%', '22%']
                }
              />
              <Page
                nextBeClick={(page) => this.nextBeClick(page)}
                pageNumber={this.props.search_results.insightTags && this.props.search_results.insightTags.pageNumber}
                pageCount={this.props.search_results.insightTags && this.props.search_results.insightTags.pageCount}
                pageSize={this.props.search_results.insightTags && this.props.search_results.insightTags.pageSize}
                nextGroupBeClick={(page) => this.nextGroupBeClick(page)}
                previousGroupBeClick={(page) => this.previousGroupBeClick(page)}
                previousBeClick={(page) => this.previousBeClick(page)}
                pageBeClick={(page) => this.pageBeClick(page)}
                total={this.props.search_results.insightTags && this.props.search_results.insightTags.total}
                hasNext={this.props.search_results.insightTags && this.props.search_results.insightTags.hasNext}
                hasPrevious={this.props.search_results.insightTags && this.props.search_results.insightTags.hasPrevious}
                pagePlus={true}
                selectRows={(page, row) => this.selectRows(page, row)}
                goToPage={(page) => this.goToPage(page)}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Insights



// WEBPACK FOOTER //
// ./src/components/InsightsInfo/Insights/Index.jsx